import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

interface Params {
  origin?: string;
  pathname?: string;
}

/**
 * Used to verify if the current app is Emerson or Fullscript.
 * @see `app/javascript/shared/hooks/useCheckIsEmerson/useCheckIsEmerson.ts` hook usage.
 * ⚠️ 99% of the time you will want to use `useCheckIsEmerson`
 *
 * @param param0
 * @returns
 */
const checkIsEmerson = (url: string | Params | URL = {}) => {
  const { pathname, origin } = typeof url === "string" ? new URL(url) : url;
  const urlIncludesEmerson = pathname?.includes("/emerson");
  const isLocalhostOrigin = origin?.includes("localhost");
  const isEmersonProdOrigin = origin?.includes("emersonecologics");
  const isReviewOrigin = origin?.includes("r.fullscript.io");
  const isEmersonDevEnv = origin?.includes("emerson.np.fs");

  if (isSSR()) {
    if (isLocalhostOrigin && urlIncludesEmerson) {
      return true;
    }

    if (isReviewOrigin && urlIncludesEmerson) {
      return true;
    }

    if (isEmersonProdOrigin) {
      return true;
    }

    if (isEmersonDevEnv) {
      return true;
    }
  } else {
    const isLocalHostname = window?.location?.hostname?.includes("localhost");
    const isReviewHostname = window?.location?.hostname?.includes("r.fullscript.io");
    const isEmersonHostname = window?.location?.hostname?.includes("emersonecologics");
    const isEmersonDevhostname = window?.location?.hostname?.includes("emerson.np.fs");
    const isEmersonPathname = window?.location?.pathname?.includes("/emerson");

    if (isLocalHostname && isEmersonPathname) {
      return true;
    }

    if (isReviewHostname && isEmersonPathname) {
      return true;
    }

    if (isEmersonHostname) {
      return true;
    }

    if (isEmersonDevhostname) {
      return true;
    }
  }

  return false;
};

export { checkIsEmerson };
